import axios from 'axios';

const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => {
      // If the request was successful, just return the response
      return response;
    },
    (error) => {
      // Check if the error is 401 (Unauthorized) or 403 (Forbidden)
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        const requestUrl = error.config?.url || '';

        // Don't intercept token refresh failures, if any
        if (
          requestUrl.includes('/api/auth/refresh') ||
          (error.response.status === 401 && requestUrl.includes('/auth/change-password'))
        ) {
          return Promise.reject(error);
        }

        // Clear user data and token from local storage
        localStorage.removeItem('token');
        localStorage.removeItem('user');

        // Remove the Authorization header from future requests
        delete axios.defaults.headers.common['Authorization'];

        // Redirect to login page
        // We use window.location to force a full page refresh, clearing all component states.
        if (!window.location.pathname.includes('/login')) {
          alert('Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.');
          window.location.href = '/login';
        }
      }

      // For all other errors, just pass them on
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
